
export default function Footer(){
  const handleCookieSettings = () => {
    // Clear consent to show banner again
    localStorage.removeItem('cookieConsent')
    window.location.reload()
  }

  return (
    <footer className="mt-16 border-t border-black/5">
      <div className="container py-10 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/AdKarrot_white_color_transparent.png"
              alt="AdKarrot"
              className="h-10 w-10"
            />
            <div>
              <div className="font-bold text-ink-900">AdKarrot LLC</div>
              <div className="text-xs text-ink-500 tracking-wider">SMART ADS, REAL RESULTS</div>
            </div>
          </div>
          <p className="text-sm text-ink-600 leading-relaxed mb-3">Smart ads, real results.</p>
          <p className="text-xs text-ink-500">Payments securely processed by Stripe.</p>
        </div>
        <div>
          <div className="font-semibold">Company</div>
          <ul className="mt-2 space-y-1 text-sm">
            <li><a href="/about">About</a></li>
            <li><a href="/case-studies">Case Studies</a></li>
            <li><a href="/resources">Resources</a></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold">Legal</div>
          <ul className="mt-2 space-y-1 text-sm">
            <li><a href="/legal/privacy">Privacy Policy</a></li>
            <li><a href="/legal/terms">Terms of Service</a></li>
            <li><a href="/legal/refunds">Refund/Cancelation Policy</a></li>
            <li><a href="/legal/cookies">Cookies Policy</a></li>
            <li>
              <button
                onClick={handleCookieSettings}
                className="text-left hover:underline"
              >
                Cookie Settings
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/5 py-4 text-center text-xs opacity-70">
        © {new Date().getFullYear()} AdKarrot LLC
      </div>
    </footer>
  )
}
